import React from "react";
import {NavLink} from "react-router-dom";

export class CrmHeaderLinks extends React.Component {

  render() {
    return (
      <ul className="nav justify-content-end top-submenu">
        <li className="nav-item">
          <NavLink activeClassName="active" to="/dashboard/contacts/">Contacts</NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/dashboard/proposals/">Proposals</NavLink>
        </li>
        <li className="nav-item">
          <a>Calendar</a>
        </li>
        <li className="nav-item">
          <NavLink activeClassName="active" to="/dashboard/project-log/">Project Log</NavLink>
        </li>
        <li className="nav-item">
          <NavLink activeClassName="active" to="/dashboard/client-profile/">Client Profile</NavLink>
        </li>
        <li className="nav-item">
          <a>Trash</a>
        </li>
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/crm/CrmHeaderLinks.jsx